module.exports = __webpack_public_path__ + "img/slide_02_en.1de0517b.jpg";